import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { openobserveRum } from '@openobserve/browser-rum';
import { openobserveLogs } from '@openobserve/browser-logs';

const options = {
  clientToken: import.meta.env.VITE_CLIENT_TOKEN || 'rumP9RINMQDbQGpm1Sn',
  applicationId: import.meta.env.VITE_APPLICATION_ID || 'lai-lender-platform',
  site: import.meta.env.VITE_SITE || 'o2.ibfdev.com',
  service: import.meta.env.VITE_SERVICE || 'lender-platform',
  env: import.meta.env.VITE_NODE_ENV || import.meta.env.MODE || 'production',
  version: import.meta.env.VITE_VERSION || '1.0.0',
  organizationIdentifier: import.meta.env.VITE_ORGANIZATION_IDENTIFIER || 'iBusiness',
  insecureHTTP: import.meta.env.VITE_INSECURE_HTTP === 'true' ? true : false,
  apiVersion: import.meta.env.VITE_API_VERSION || 'v1',
};

openobserveRum.init({
  applicationId: options.applicationId, // required, any string identifying your application
  clientToken: options.clientToken,
  site: options.site,
  organizationIdentifier: options.organizationIdentifier,
  service: options.service,
  env: options.env,
  version: options.version,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  apiVersion: options.apiVersion,
  insecureHTTP: options.insecureHTTP,
  defaultPrivacyLevel: 'allow' // 'allow' or 'mask-user-input' or 'mask'. Use one of the 3 values.
});

openobserveLogs.init({
  clientToken: options.clientToken,
  site: options.site,
  organizationIdentifier: options.organizationIdentifier,
  service: options.service,
  env: options.env,
  version: options.version,
  forwardErrorsToLogs: true,
  insecureHTTP: options.insecureHTTP,
  apiVersion: options.apiVersion,
});

// // You can set a user context
// openobserveRum.setUser({
//   id: "1",
//   name: "Captain Hook",
//   email: "captainhook@example.com",
// });

openobserveRum.startSessionReplayRecording();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
